export enum RECURRENCE_INTERVAL {
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
  BIMONTHLY = 'BIMONTHLY',
  TRIMESTERLY = 'TRIMESTERLY',
  SEMIANNUALLY = 'SEMIANNUALLY',
  YEARLY = 'YEARLY',
}
